import { render, staticRenderFns } from "./OverlayItem.vue?vue&type=template&id=e71ac2b0&"
import script from "./OverlayItem.vue?vue&type=script&lang=js&"
export * from "./OverlayItem.vue?vue&type=script&lang=js&"
import style0 from "./OverlayItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports